import { render } from "./S341436.vue?vue&type=template&id=5a1ea31e&scoped=true"
const script = {}

import "./S341436.vue?vue&type=style&index=0&id=5a1ea31e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5a1ea31e"

export default script